import Reveal from "@/components/Reveal";
import VocabTag from "@/components/VocabTag";

/**
 * Thesis — converted to a typographic poster.
 * Single axiom carries the section. No comparison columns.
 * Used as a poster counterpoint between image panels.
 */
export default function Thesis() {
  return (
    <section
      id="thesis"
      data-testid="thesis-section"
      className="relative border-b border-[color:var(--g1-rule)]"
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 lg:px-14 py-24 md:py-36 lg:py-48">
        {/* Section head */}
        <div className="grid grid-cols-12 gap-8 mb-12 md:mb-16 items-start">
          <div className="col-span-6 md:col-span-3 lg:col-span-2">
            <Reveal>
              <div className="g1-label">SEC. 01</div>
              <div className="g1-eyebrow mt-2">Thesis</div>
            </Reveal>
          </div>
          <div className="col-span-6 md:col-span-3 lg:col-span-2 md:col-start-10 lg:col-start-11 text-right flex flex-col items-end gap-2">
            <Reveal>
              <VocabTag kind="INTELLIGENCE" />
            </Reveal>
          </div>
        </div>

        {/* Poster statement */}
        <Reveal delay={80}>
          <h2
            data-testid="thesis-heading"
            className="g1-poster"
          >
            <span className="block text-[26px] sm:text-[40px] md:text-[60px] lg:text-[76px] xl:text-[88px] text-[color:var(--g1-ink-2)]">
              Generalist AI <br />
              writes the memo.
            </span>
            <span className="block mt-4 md:mt-8 text-[38px] sm:text-[58px] md:text-[88px] lg:text-[112px] xl:text-[128px]">
              <span className="g1-poster-italic">Industrial AGI</span> <br />
              runs the factory.
            </span>
          </h2>
        </Reveal>

        {/* Footer rail */}
        <div className="mt-14 md:mt-24 border-t border-[color:var(--g1-ink)] pt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="g1-label text-[color:var(--g1-ink-2)] max-w-[38ch]">
            Content Generation → Output Generation
          </div>
        </div>
      </div>
    </section>
  );
}
